/* eslint-disable @typescript-eslint/no-non-null-assertion */
import cn from 'classnames';
import * as React from 'react';
import Select from 'react-select';

import {
  getReminderLabel,
  reminderOptions,
  ReminderSelectOption,
  ReminderSelectSingleValue,
  reminderSelectStyles,
  UserSelectDropDownIndicator,
} from '../../select-styles';
import { CalendarReminder, OnChangeReminderCallback } from '../types/calendar';
interface SelectReminderProps {
  reminderOffset?: CalendarReminder;
  onChange?: OnChangeReminderCallback;
  disable?: 'date' | 'recurring' | 'none';
}
const { useState } = React;

export const SelectReminder = ({
  reminderOffset,
  onChange,
  disable = 'none',
}: SelectReminderProps) => {
  const handleChange = (value) => {
    onChange?.(value.value);
    setReminder(value.value);
  };
  const [reminder, setReminder] = useState<CalendarReminder>(reminderOffset || '');
  return (
    <div className="w-full flex-col px-18 py-14">
      <label htmlFor="assigner" className={cn(' text-sm  text-gray-500 font-medium', {})}>
        Set task reminder
      </label>
      <Select
        options={reminderOptions}
        menuPortalTarget={document.body}
        onChange={handleChange}
        styles={reminderSelectStyles}
        menuPlacement="bottom"
        isDisabled={disable !== 'none'}
        // placeholder="none"
        value={{
          value: reminder || 0,
          label: getReminderLabel[reminder || 0],
        }}
        className="mt-10"
        components={{
          DropdownIndicator: UserSelectDropDownIndicator,
          IndicatorSeparator: () => null,
          SingleValue: ReminderSelectSingleValue,
          Option: ReminderSelectOption,
        }}
      />
      {disable === 'date' ? (
        <p className="py-8 text-red-500 text-xs">Select date to set a reminder</p>
      ) : disable === 'recurring' ? (
        <p className="py-8 text-red-500 text-xs">
          Reminders cannot be set for recurring tasks. Disable repeat to set a reminder.
        </p>
      ) : (
        <></>
      )}
    </div>
  );
};
